import { render, staticRenderFns } from "./PriceEdition.vue?vue&type=template&id=adaf4b58&scoped=true"
import script from "./PriceEdition.vue?vue&type=script&lang=js"
export * from "./PriceEdition.vue?vue&type=script&lang=js"
import style0 from "./PriceEdition.vue?vue&type=style&index=0&id=adaf4b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaf4b58",
  null
  
)

export default component.exports